import { useState } from "react";
import type { Benutzer } from "../../shared/types.js";
import { anmelden, ladeProfil } from "../api.js";

export function Anmeldung({ beiAnmeldung }: { beiAnmeldung: (b: Benutzer) => void }) {
  const [email, setEmail] = useState("");
  const [passwort, setPasswort] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await anmelden(email, passwort);
      // Profil laden — holt zugleich CSRF-Token und KDF-Parameter.
      beiAnmeldung(await ladeProfil());
    } catch (err) {
      setFehler(err instanceof Error ? err.message : "Anmeldung fehlgeschlagen.");
      setPasswort("");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="anmelde-seite">
      <form className="anmelde-karte" onSubmit={absenden}>
        <img src="/logo-engelke.png" alt="Gebr. Engelke — Große Mühle seit 1714" />

        {fehler && (
          <div className="meldung fehler" role="alert">
            {fehler}
          </div>
        )}

        <div className="feld">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="feld">
          <label htmlFor="passwort">Passwort</label>
          <input
            id="passwort"
            type="password"
            autoComplete="current-password"
            required
            maxLength={128}
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
          />
        </div>

        <button className="knopf" type="submit" disabled={laeuft}>
          {laeuft ? "Anmeldung läuft …" : "Anmelden"}
        </button>

        <p className="hinweistext" style={{ textAlign: "center", marginTop: "1.2rem" }}>
          Zugang erhalten Sie von Ihrem Administrator.
        </p>
      </form>
    </div>
  );
}
